"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@/styles/index.scss");
require("@/components/hero/style.scss");
require("@/components/button/style.scss");
require("@/components/textblock/style.scss");
require("@/components/text-and-image/style.scss");
require("@/components/selected-campaigns/style.scss");
require("@/components/spinner/style.scss");
var header_1 = __importDefault(require("@/components/header"));
var hero_1 = __importDefault(require("@/components/hero"));
var newsletter_signup_1 = __importDefault(require("@/components/newsletter-signup"));
var recipe_signup_1 = __importDefault(require("@/components/recipe-signup"));
var cookie_age_consent_1 = __importDefault(require("@/components/cookie-age-consent"));
exports.default = (function () {
    var _a;
    (_a = document.querySelectorAll("body").item(0)) === null || _a === void 0 ? void 0 : _a.classList.add("ready");
    var header = new header_1.default({
        target: document.querySelector("[data-hero]"),
        element: document.querySelector("[data-header]"),
    });
    var hero = new hero_1.default(document.querySelector("[data-hero-background]"));
    var newsletter = new newsletter_signup_1.default(document.querySelector("[data-newsletter-signup]"));
    var recipe = new recipe_signup_1.default(document.querySelector("[data-recipe-signup]"));
    var consent = new cookie_age_consent_1.default(document.querySelector("[data-cookie-age-consent]"));
})();
